import React from 'react';
import { ZapIcon } from 'lucide-react';
export function SectionDivider() {
  return <div className="w-full bg-red-gradient py-5 md:py-6 shadow-[0_0_30px_rgba(178,34,52,0.4)] relative z-20 border-y border-red-900" data-id="element-358">
      <div className="max-w-5xl mx-auto px-4 flex items-center justify-center gap-4 md:gap-6" data-id="element-359">
        <ZapIcon className="w-5 h-5 md:w-6 md:h-6 text-white animate-pulse" data-id="element-360" />
        <h2 className="text-white font-black text-lg md:text-2xl tracking-[0.2em] uppercase text-center text-shadow-sm" data-id="element-361">
          Special Bundle Offer — Limited Time
        </h2>
        <ZapIcon className="w-5 h-5 md:w-6 md:h-6 text-white animate-pulse" data-id="element-362" />
      </div>
    </div>;
}